import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '1000px',
      margin: '0 auto',
      '& .MuiButton-root': {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(2),
        zIndex: 1299,
        [theme.breakpoints.down('xs')]: {
          marginTop: theme.spacing(2),
          zIndex: 1,
        },
      }
    },
    listCard: {
      marginBottom: theme.spacing(1),
      backgroundColor: theme.palette.grey[200]
    },
    listImg: {
      maxHeight: '80px',
      margin: theme.spacing(1)
    },
    listUrl: {
      padding: theme.spacing(1),
      fontFamily: 'VisbyCF-Bold',
      alignItems: 'center',
      display: 'flex'
    }
  })
);

export default useStyles;